import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/Marquee";
import { HowItWorks } from "@/components/HowItWorks";
import { Screenshots } from "@/components/Screenshots";
import { SosStory } from "@/components/SosStory";
import { Faq } from "@/components/Faq";
import { Footer } from "@/components/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page">
      <Nav />
      <Hero />
      <EditorialMarquee />
      <HowItWorks />
      <Screenshots />
      <SosStory />
      <Faq />
      <Footer />
    </main>
  );
}
